import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const signOut = (toast) => {
  if (toast) {
    localStorage.setItem("signOutToast", JSON.stringify(toast));
  }
  return swRequest({
    path: "/api/users/sign_out",
  }).then(() => {
    localStorage.removeItem("provider");
    localStorage.removeItem("clarity");
    window.location = "/signin";
  });
};
